import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlobalStatusPpsi } from '../actions';
import {
  getGlobalStatusError,
  getIsFetchingGlobalStatus,
  getGlobalStatusPpsis
} from '../selectors';

const useGlobalStatusPpsis = () => {
  const dispatch = useDispatch();
  const isFetchingPpsis = useSelector(getIsFetchingGlobalStatus);
  const globalStatusPpsis = useSelector(getGlobalStatusPpsis);
  const errorFetchingPpsis = useSelector(getGlobalStatusError);

  useEffect(() => {
    dispatch(fetchGlobalStatusPpsi());
  }, [dispatch]);

  return [isFetchingPpsis, globalStatusPpsis, errorFetchingPpsis];
};

export default useGlobalStatusPpsis;
